import { DrawerDialog } from '@/common/components/drawer-dialog';
import GasSaverMarketingTileDrawerDialogCopy from './gas-saver-marketing-tile-drawer-dialog-copy';

interface GasSaverMarketingTileDrawerDialogProps {
  trigger: React.ReactNode;
  gasSaverCents: string;
}
export default function GasSaverMarketingTileDrawerDialog({
  trigger,
  gasSaverCents,
}: GasSaverMarketingTileDrawerDialogProps) {
  return (
    <DrawerDialog trigger={trigger} title="Flexcar Gas Saver™">
      <GasSaverMarketingTileDrawerDialogCopy gasSaverCents={gasSaverCents} />
    </DrawerDialog>
  );
}
